import { Box, makeStyles, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import emptyGuardianImage from '../../assets/images/emptyData/NoGuardianImage.png';

const useStyle = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageStyle: {
    width: '100%',
    maxWidth: 500,
  },
}));
const EmptyGuardian = props => {
  const { imageClass, text, isTop } = props;
  const theme = useTheme();
  const classes = useStyle(theme);
  return (
    <Box className={clsx(classes.container)}>
      {isTop && text ? text : null}
      <img
        src={emptyGuardianImage}
        className={clsx(classes.imageStyle, imageClass)}
      />
      {!isTop && text ? text : null}
    </Box>
  );
};
EmptyGuardian.defaultProps = {
  imageClass: '',
  text: '',
  isTop: false,
};

export default EmptyGuardian;
